import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from "reactstrap";
import boxes from "../../assets/img/brand/boxes.png";
import backgroundImage from "../../assets/img/brand/Login-Background.jpg";

import Auth from "../../services/authentication";
const auth = new Auth();

const REACT_APP_ASSETS_S3_URL = process.env.REACT_APP_ASSETS_S3_URL;

export default class ForgotPassword extends Component {
  state = {
    email: "",
    showMessage: false,
  };

  handleInput = (e) => {
    const {
      target: { value, name },
    } = e;
    this.setState({ [name]: value, error: "" });
  };

  handleResetPassword = (e) => {
    e.preventDefault();
    const { email } = this.state;
    auth.resetPassword(email);
    this.setState({ showMessage: true });
  };

  render() {
    const { email, error } = this.state;

    return (
      <div
        className="app flex-row align-items-center bg-grad"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup className="shadow-lg">
                <Card className="p-4" style={{ border: "none" }}>
                  <CardBody className="text-center align-items-center">
                    <div className="col d-flex justify-content-center mb-4">
                      <a href="https://speedyfreight.com/">
                        <img
                          src={`${REACT_APP_ASSETS_S3_URL}/images/logo/LogoGroup.png`}
                          alt="SpeedyFulfil Logo"
                          style={{ height: "auto", maxWidth: "320px" }}
                        />
                      </a>
                    </div>
                    {!this.state.showMessage && (
                      <Form onSubmit={this.handleResetPassword}>
                        <InputGroup className="mb-2">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-user" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="text"
                            placeholder="Email"
                            autoComplete="email"
                            name="email"
                            onChange={this.handleInput}
                            value={email}
                          />
                        </InputGroup>

                        {Boolean(error) && (
                          <Row className="justify-content-center">
                            <Col md="8">
                              <p className="text-danger">{error}</p>
                            </Col>
                          </Row>
                        )}
                        <Button
                          className="px-4 login-button"
                          style={{
                            backgroundColor: "#da291c",
                            border: "none",
                            height: 35,
                            width: 200,
                            borderRadius: 20,
                          }}
                        >
                          <strong>Reset Password</strong>
                        </Button>
                      </Form>
                    )}

                    {this.state.showMessage && (
                      <>
                        <p
                          style={{
                            marginTop: 20,
                          }}
                        >
                          Thanks, you will receive an email to reset your
                          password shortly.
                        </p>

                        <Button
                          className="px-4 login-button"
                          onClick={() => this.props.history.push("/login")}
                          style={{
                            backgroundColor: "#da291c",
                            border: "none",
                            height: 35,
                            width: 200,
                            borderRadius: 20,
                          }}
                        >
                          <strong>Login</strong>
                        </Button>
                      </>
                    )}
                  </CardBody>
                </Card>
                <Card
                  style={{ border: "none" }}
                  className="text-white text-center p-4 login-page-register-card"
                >
                  <CardBody>
                    <div className="col d-flex justify-content-center">
                      <a href="https://speedyfreight.com/">
                        <img
                          src={boxes}
                          alt="SpeedyFulfil Logo"
                          style={{
                            maxWidth: "350px",
                            height: "auto",
                            marginTop: 15,
                          }}
                        />
                      </a>
                    </div>
                    <div>
                      <p className="mt-5">
                        Simplify your supply chain with our{" "}
                        <strong>FLEXIBLE PARCEL AND FULFILMENT SERVICES</strong>
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
